module.exports = "https://www.gc-qa.gnp.com.mx/5c7f90ba11eaadd8645b177475997c4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/videos/vida/5.png
// module id = 1064
// module chunks = 0 1